export default "__VITE_ASSET__CAREy$Ia__"